export const ACTIONS = {
	SET_TOAST_MESSAGE: 'SET_TOAST_MESSAGE',
	REMOVE_TOAST: 'REMOVE_TOAST',
	ADD_OVERLAY: 'ADD_OVERLAY',
	REMOVE_OVERLAY: 'REMOVE_OVERLAY',
	SET_VALID_QRs: 'SET_VALID_QRs',
};